import { useEffect } from "react";

import { useParams } from "react-router-dom";

import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { selectAccessesAreLoading } from "Reducers/access/environmentTypeAccess/environmentTypeAccess.selectors";
import { getEnvironmentTypeAccessesThunk } from "Reducers/access/environmentTypeAccess/thunks/getEnvironmentTypeAccesses.thunk";
import { useLoadInvitations } from "Reducers/access/invitation/invitation.hooks";
import { getProjectAccessesThunk } from "Reducers/access/projectAccess/thunks/getProjectAccesses.thunk";
import { selectFeatureOrganizationsEnabled } from "Reducers/featureFlags/featureFlags.selectors";
import { gitProjectSelector } from "Reducers/project/project";
import { useListUserAccessesByProjectId } from "Reducers/userAccess/hooks/useListUserAccessesByProjectId";
import { useAppDispatch, useAppSelector } from "Store/hooks";

export const useLoadAccesses = () => {
  const loading = useAppSelector(selectAccessesAreLoading);
  const organizationEnabled = useAppSelector(selectFeatureOrganizationsEnabled);
  const dispatch = useAppDispatch();
  const { organizationId, projectId } = useParams<{
    organizationId: string;
    projectId: string;
  }>();

  const project = useSelectorWithUrlParams(gitProjectSelector);

  useEffect(() => {
    if (project && projectId && organizationId && !organizationEnabled) {
      dispatch(getEnvironmentTypeAccessesThunk({ projectId }));
      dispatch(getProjectAccessesThunk({ project, organizationId }));
    }
  }, [dispatch, organizationId, project, projectId, organizationEnabled]);

  return loading;
};

// useLoadInvitationsAndAccesses fetches both pending invitations and existing access permissions (users)
// since we show them together in the UI
export const useLoadInvitationsAndAccesses = () => {
  const organizationEnabled = useAppSelector(selectFeatureOrganizationsEnabled);
  const invitationsLoading = useLoadInvitations();

  const accessesLoading = useLoadAccesses();
  const [, userAccessesLoading] = useListUserAccessesByProjectId();
  if (!organizationEnabled) {
    return invitationsLoading || accessesLoading;
  } else {
    return invitationsLoading || userAccessesLoading;
  }
};
